var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("demo")]),_c('h3',[_vm._v("store")]),_c('h4',[_vm._v("count: "+_vm._s(_vm.count))]),_c('h4',[_vm._v("getCount: "+_vm._s(_vm.getAge))]),_c('h4',[_c('button',{on:{"click":_vm.increment}},[_vm._v("inCream")])]),_c('iframe',{attrs:{"src":"vr/index.html","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }